export default "/images/vendor/flag-icons/flags/4x3/pg.svg?7248ade59c2b54a0a3483546335652f7";